import { decrypt, encrypt } from "../security/encryption";

/**
 * Retrieves the access token from local storage, decrypts it, and returns it.
 * Returns null if no access token is stored.
 * @returns {Promise<string | null>} The decrypted access token, or null if no access token is stored.
 */
export const getAccessToken = async () => {
  const encrypted = localStorage.getItem("token");
  if (!encrypted) return null;
  return await decrypt(encrypted);
};

/**
 * Sets the access token in local storage, encrypting it before storing.
 * @param {string} token The access token to store.
 * @returns {Promise<void>} A promise that resolves when the access token has been stored.
 */
export const setAccessToken = async (token: string | null) => {
  if (!token) {
    localStorage.removeItem("token");
    return;
  }
  localStorage.setItem("token", await encrypt(token));
};